import { Tooltip } from "../Tooltip/Tooltip";
import { TooltipIcon } from "../TooltipIcon";

export interface TooltipWithIconProps {
  content: string;
}

export const TooltipWithIcon = ({ content }: TooltipWithIconProps) => {
  return (
    <Tooltip content={content}>
      <TooltipIcon />
    </Tooltip>
  );
};
